import { render, staticRenderFns } from "./population-statistics.vue?vue&type=template&id=bd98ebd4&scoped=true&"
import script from "./population-statistics.vue?vue&type=script&lang=ts&"
export * from "./population-statistics.vue?vue&type=script&lang=ts&"
import style0 from "./population-statistics.vue?vue&type=style&index=0&id=bd98ebd4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd98ebd4",
  null
  
)

export default component.exports